import FaireSourceCartIOsPage from "@faire/prototype-playground/workspace/am/faire-source-cart-ios";
import FaireSourceCartRefreshPage from "@faire/prototype-playground/workspace/am/faire-source-cart-refresh";
import MultiMinimumProgressBarPage from "@faire/prototype-playground/workspace/am/multi-minimum-progress-bar";
import NavItemNuxPage from "@faire/prototype-playground/workspace/am/nav-item-nux";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const FaireSourceCheckoutUpsellPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/am/faire-source-checkout-upsell")
);

const QuickViewDownFunnelPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/am/quick-view-down-funnel")
);

const FaireSourceCartVisionPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/am/faire-source-cart-vision")
);

const AtcShoppingLoopEndToEndPage = withCompass(
  () => import("../../pages/AtcShoppingLoopEndToEndPage")
);
const AtcToastNonPdpPage = withCompass(
  () => import("../../pages/AtcToastNonPdpPage")
);
const FaireSourceAboutPage = withCompass(
  () => import("../../pages/FaireSourceAboutPage")
);
const FaireSourceAtcShoppingLoopNativePage = lazy(
  () => import("../../pages/FaireSourceAtcShoppingLoopNativePage")
);
const FaireSourceAtcShoppingLoopPage = withCompass(
  () => import("../../pages/FaireSourceAtcShoppingLoopPage")
);
const FaireSourceCardPage = lazy(
  () => import("../../pages/FaireSourceCardPage")
);
const FaireSourceNonInsidersPage = withCompass(
  () => import("../../pages/FaireSourceNonInsidersPage")
);
const MyOrdersBatchingPage = lazy(
  () => import("../../pages/MyOrdersBatchingPage")
);
const NonFaireSourceAtcShoppingLoopNativePage = lazy(
  () => import("../../pages/NonFaireSourceAtcShoppingLoopNativePage")
);
const NonFaireSourceAtcShoppingLoopPage = withCompass(
  () => import("../../pages/NonFaireSourceAtcShoppingLoopPage")
);
const UpdatedAtcInteractionPage = withCompass(
  () => import("../../pages/UpdatedAtcInteractionPage")
);
const UpdatedNativeAtcShoppingLoopPage = lazy(
  () => import("../../pages/UpdatedNativeAtcShoppingLoopPage")
);
const FaireSourceAtcConfirmationPage = withCompass(
  () => import("../../pages/FaireSourceAtcConfirmationPage")
);
const FaireSourceCartFullPage = lazy(
  () => import("../../pages/FaireSourceCartFullPage")
);
const SideCartExplorationPage = withCompass(
  () => import("../../pages/SideCartExplorationPage")
);
const MyOrdersMentalModelPage = lazy(
  () => import("../../pages/MyOrdersMentalModelPage")
);
const FsCartConversionPage = lazy(
  () => import("../../pages/FsCartConversionPage")
);
const BaselineHackTestPage = lazy(
  () => import("../../pages/BaselineHackTestPage")
);
const WatsonTestPage = lazy(() => import("../../pages/WatsonTestPage"));
const TestWithJamesPage = lazy(() => import("../../pages/TestWithJamesPage"));
const NativeCartOrderSummaryPage = lazy(
  () => import("../../pages/NativeCartOrderSummaryPage")
);

export function AbbyMillsRoutes() {
  return (
    <Switch>
      <Route
        path="/am/faire-source-cart-vision"
        component={FaireSourceCartVisionPage}
      />
      <Route path="/am/my-orders-batching" component={MyOrdersBatchingPage} />
      <Route path="/am/faire-source-card" component={FaireSourceCardPage} />
      <Route
        path="/am/faire-source-atc-shopping-loop"
        component={FaireSourceAtcShoppingLoopPage}
      />
      <Route
        path="/am/atc-shopping-loop-end-to-end"
        component={AtcShoppingLoopEndToEndPage}
      />
      <Route
        path="/am/updated-atc-interaction"
        component={UpdatedAtcInteractionPage}
      />
      <Route
        path="/am/faire-source-atc-shopping-loop-native"
        component={FaireSourceAtcShoppingLoopNativePage}
      />
      <Route
        path="/am/updated-native-atc-shopping-loop"
        component={UpdatedNativeAtcShoppingLoopPage}
      />
      <Route
        path="/am/non-faire-source-atc-shopping-loop"
        component={NonFaireSourceAtcShoppingLoopPage}
      />
      <Route
        path="/am/non-faire-source-atc-shopping-loop-native"
        component={NonFaireSourceAtcShoppingLoopNativePage}
      />
      <Route path="/am/atc-toast-non-pdp" component={AtcToastNonPdpPage} />
      <Route
        path="/am/faire-source-non-insiders"
        component={FaireSourceNonInsidersPage}
      />
      <Route path="/am/faire-source-about" component={FaireSourceAboutPage} />
      <Route
        path="/am/faire-source-atc-confirmation"
        component={FaireSourceAtcConfirmationPage}
      />
      <Route path="/am/faire-source-cart" component={FaireSourceCartFullPage} />
      <Route
        path="/am/side-cart-exploration"
        component={SideCartExplorationPage}
      />
      <Route
        path="/am/my-orders-mental-model"
        component={MyOrdersMentalModelPage}
      />
      <Route path="/am/fs-cart-conversion" component={FsCartConversionPage} />
      <Route path="/am/baseline-hack-test" component={BaselineHackTestPage} />
      <Route
        path="/am/faire-source-cart-ios"
        component={FaireSourceCartIOsPage}
      />
      <Route
        path="/am/faire-source-cart-refresh"
        component={FaireSourceCartRefreshPage}
      />
      <Route
        path="/am/faire-source-checkout-upsell"
        component={FaireSourceCheckoutUpsellPage}
      />
      <Route path="/am/watson-test" component={WatsonTestPage} />
      <Route path="/am/test-with-james" component={TestWithJamesPage} />
      <Route
        path="/am/native-cart-order-summary"
        component={NativeCartOrderSummaryPage}
      />
      <Route
        path="/am/multi-minimum-progress-bar"
        component={MultiMinimumProgressBarPage}
      />
      <Route path="/am/nav-item-nux" component={NavItemNuxPage} />
      <Route
        path="/am/quick-view-down-funnel"
        component={QuickViewDownFunnelPage}
      />
    </Switch>
  );
}

export const slug = "am";
